// Simple in-memory store so Waste charts can share computed data with GHG Inventory
// Data persists for the session (until reload). This intentionally mirrors the
// approach we use for VMT (global store + window var fallback).

export interface WasteSeries {
  years: number[];
  emissionsByYear: Record<number, number>; // MT CO2e
  intensityByYear: Record<number, number>; // tCO2e/ton
  wasteTonsByYear: Record<number, number>; // tons
}

const wasteStore: Map<string, WasteSeries> = new Map();

// Normalize key to be stable across city/county spellings
function keyFor(location: string): string {
  return (location || '').trim().toLowerCase();
}

export function setWasteDataForInventory(location: string, data: WasteSeries): void {
  const k = keyFor(location);
  wasteStore.set(k, data);
  // Expose on window for debugging or non-module consumers if needed
  if (typeof window !== 'undefined') {
    (window as any).__wasteInventoryData__ = (window as any).__wasteInventoryData__ || {};
    (window as any).__wasteInventoryData__[k] = data;
  }
}

export function getWasteDataForInventory(location: string): WasteSeries | null {
  const k = keyFor(location);
  if (wasteStore.has(k)) return wasteStore.get(k)!;
  if (typeof window !== 'undefined') {
    const fromWin = (window as any).__wasteInventoryData__?.[k];
    if (fromWin) return fromWin as WasteSeries;
  }
  return null;
}


